<style scoped>
  @import "css/card-input.scss";
</style>

<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import sharedService from '../../../../utils/shared-service'
import creditCardType from 'credit-card-type'
import { CARD_TYPES, CLICK_TO_PAY, MAX_LENGTH, MASK_CARD_16_DIGIT_FORMAT, MASK_CARD_19_DIGIT_FORMAT } from '@/utils/constant.js'
import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { mapGetters } from 'vuex'

Vue.use(Vuelidate)

export default {
  name: 'CardInput',
  directives: {
    mask
  },
  props: {
    paymentMode: {
      type: String
    }
  },
  data () {
    return {
      cardNumber: '',
      cardType: 'mastercard',
      activeUrl: 'blank.png',
      cardTypeValueErr: false,
      cardLengthErr: false,
      cardNumberFormat: MASK_CARD_16_DIGIT_FORMAT
    }
  },

  computed: {
    ...mapGetters(['checkoutProgress', 'enableMPT']),

    maxLengthValidation: function () {
      return MAX_LENGTH.find((item) => item.card === this.cardType)
    }
  },

  validations () {
    return {
      cardNumber: {
        required,
        minLength: minLength(22),
        maxLength: maxLength(this.maxLengthValidation.maxLength)
      }
    }
  },

  watch: {
    paymentMode: {
      handler () {
        if (this.paymentMode === CLICK_TO_PAY) {
          this.cardNumber = ''
          this.cardTypeValueErr = ''
        }
      }
    }
  },

  methods: {

    /**
     * This method verify the applicable brands the return respective card type
     */
    getCardNetwork (cardType) {
      return creditCardType(cardType).map(({
        type
      }) => type)
    },

    /**
     * get the blank image if no card type found
     * */
    getBlankCardType (value) {
      this.activeUrl = 'blank.png'
      this.cardTypeValueErr = value
    },

    /**
     * This method emits the card input type
     * */
    emitCardType () {
      if (this.cardNumber) {
        this.$emit('input', {
          cardNumber: this.cardNumber
        })
      }
    },

    /* eslint complexity: ["error", 10] */
    /**
     * This method sets the card type based on card number
     * @param cardNumber
     */
    validateApplicableBrands () {
      if (this.cardNumber && this.cardNumber.length >= 4) {
        this.cardLengthErr = true
        let cardNetwork = this.getCardNetwork(this.cardNumber)
        this.emitCardBrand(cardNetwork)
        console.log('[START] - Card Network', cardNetwork)
        this.cardType = CARD_TYPES[cardNetwork[0]] || ''
        this.cardNumberFormat = this.cardType === 'maestro' ? MASK_CARD_19_DIGIT_FORMAT : MASK_CARD_16_DIGIT_FORMAT
        if (this.cardNumber.length > 4 && this.cardNumber.length < 15) {
          return
        }
        if (this.cardType) {
          this.activeUrl = this.cardType === 'maestro' ? 'mastercard_logo.png' : this.cardType + '_logo.png'
          this.cardTypeValueErr = false
          this.emitCardType()
        } else {
          this.getBlankCardType(true)
        }
      } else {
        this.activeUrl = 'blank.png'
        this.cardTypeValueErr = false
        this.cardLengthErr = false
      }
    },

    /**
     * This method emits the card number and emits card type
     * @param cardNumber
     */
    emitCardInput (cardNumber) {
      if (cardNumber !== '' && undefined !== cardNumber) {
        cardNumber = sharedService.unmask(cardNumber)
        this.validateApplicableBrands()
      } else {
        this.getBlankCardType(false)
      }
    },

    emitCardBrand (cardBrand) {
      if (this.enableMPT) {
        this.$emit('cardBrand', cardBrand)
      }
    }
  }
}
</script>

<template>
  <div>
    <div
      id="iframeContainer"
      ref="iframeContainer"
      :class="[
        checkoutProgress ? 'show' : '',
      ]"
      class="iframe-container slide-in">
      <div class="iframe-foreground">
        <iframe
          id="checkoutIframe"
          ref="iframe"
          class="iframe-checkout"
          name="checkout-iframe" />
      </div>
      <div
        id="iframeBackground"
        ref="iframeBackground"
        class="iframe-background" />
    </div>
    <div class="form-group my-3">
      <input
        v-mask="cardNumberFormat"
        id="input-card-number"
        v-model.trim="cardNumber"
        :label="'Card Number'"
        class="form-control input-lg"
        type="text"
        name="cardNumber"
        placeholder="Card number"
        data-test="card-number"
        @input="emitCardInput(cardNumber)"
      >
      <span class="modal-fs">
        <img
          :src="require('@/assets/images/cards/' +activeUrl)"
          alt="No Image"
          class="card-type-img"
        >
      </span>
      <small
        v-if="(!$v.cardNumber.minLength && cardLengthErr) || !$v.cardNumber.maxLength"
        id="cardNumberError"
        class="form-text text-danger"
      >
        {{ $t ('errorMessages.invalidCardNumber') }}
      </small>
      <small
        v-if="cardTypeValueErr"
        id="cardTypeError"
        class="form-text text-danger"
      >
        {{ $t ('errorMessages.invalidCardType') }}
      </small>
    </div>
  </div>
</template>
